<template>
  <!-- 外调报告记录 -->
  <div class="group-relationship-mana">
    <a-card style="margin-bottom: 10px">
      <!-- <search-view
        :renderItem="RELATION_SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view> -->
      <a-form-model
        ref="initSearchForm"
        layout="vertical"
        :model="initSearchForm"
      >
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="渠道" prop="channel">
              <a-select
                show-search
                option-filter-prop="children"
                v-model="initSearchForm.channel"
                @change="bureauNameList"
                allowClear
                placeholder="请输入渠道"
              >
                <a-select-option
                  v-for="item in objectList"
                  :value="item.value"
                  :key="item.value"
                >
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="报告机构" prop="reportType">
              <a-select
                show-search
                option-filter-prop="children"
                v-model="initSearchForm.reportType"
                allowClear
                placeholder="请输入报告机构"
              >
                <a-select-option
                  v-for="item in selectList"
                  :value="item.value"
                  :key="item.value"
                >
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="查询时间">
              <a-range-picker
                format="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD 00:00:00"
                v-model="applyRangeDate"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="客户名称" prop="customerName">
              <a-input
                v-model="initSearchForm.customerName"
                placeholder="请输入客户名称"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="查询结果" prop="status">
              <a-select
                show-search
                option-filter-prop="children"
                v-model="initSearchForm.status"
                allowClear
                placeholder="请输入查询结果"
              >
                <a-select-option
                  v-for="item in statusList"
                  :value="item.value"
                  :key="item.value"
                >
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="24" style="text-align: right">
            <a-button
              type="primary"
              style="margin-right: 15px"
              html-type="submit"
              @click="handleSearch(initSearchForm)"
            >
              查询
            </a-button>
            <a-button @click="reset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card>
      <div class="right">
        <a-button type="primary" icon="download" @click="exportFile">
          下载
        </a-button>
      </div>

      <TableView
        :data="tableData"
        rowKey="index"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
      ></TableView>
    </a-card>
  </div>
</template>

<script>
import { TableView } from 'lxfintech-fe'
import { getRelationList, download } from './api'
import cloneDeep from 'lodash/cloneDeep'
// import { formatDate } from 'utils/util'

export default {
  name: 'outward-record',
  data() {
    const initSearchForm = {
      channel: '',
      reportType: '',
      customerName: '',
      status: '',
      startTime: '',
      endTime: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      selectList: [],
      objectList: [
        {
          text: 'LeCredit',
          value: 'Le-Credit',
        },
        {
          text: 'LCFC',
          value: 'LCFC',
        },
        {
          text: '百应SaaS',
          value: 'SaaS',
        },
      ],
      statusList: [
        {
          text: '全部',
          value: 0,
        },
        {
          text: '成功',
          value: 1,
        },
        {
          text: '失败',
          value: 2,
        },
      ],
      // RELATION_SEARCH_SCHEMA: [
      //   {
      //     itemName: 'channel',
      //     label: '渠道',
      //     allowClear: true,
      //     handleChange: this.bureauNameList,
      //     type: 'select',
      //     selectList: [
      //       {
      //         text: 'LeCredit',
      //         value: 'Le-Credit',
      //       },
      //       {
      //         text: '百应SaaS',
      //         value: 'SaaS',
      //       },
      //     ],
      //   },
      //   {
      //     label: '报告机构',
      //     itemName: 'reportType',
      //     type: 'select',
      //     selectList: [],
      //     allowClear: true,
      //   },
      //   {
      //     itemName: 'customerName',
      //     label: '客户名称',
      //     allowClear: true,
      //     type: 'input',
      //   },
      //   {
      //     itemName: 'status',
      //     label: '查询结果',
      //     type: 'select',
      //     allowClear: true,
      //   },
      //   {
      //     itemName: 'applyRangeDate',
      //     label: '查询时间',
      //     type: 'rangePicker',
      //     allowClear: true,
      //   },
      // ],
      tableLoading: false,
      initSearchForm,
      applyRangeDate: [],
      searchForm,
      tableData: [],
      columns: [
        {
          fixed: 'left',
          title: '序号',
          width: 60,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '报告机构',
          dataIndex: 'agenciesReport',
          width: 120,
        },
        {
          title: '客户名称',
          dataIndex: 'customerName',
          width: 120,
        },
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: 120,
        },
        {
          title: '查询结果',
          dataIndex: 'result',
          width: 120,
        },
        {
          title: '渠道',
          dataIndex: 'channel',
          width: 120,
        },
        {
          title: '查询时间',
          dataIndex: 'time',
          width: 120,
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      SCROLL: { x: 1150 },
    }
  },
  mounted() {
    this._getRelationList(this.initSearchForm)
  },
  methods: {
    bureauNameList(name) {
      this.initSearchForm.reportType = ''
      if (name === 'Le-Credit') {
        this.selectList = [
          {
            text: '邓白氏',
            value: 'DNB',
          },
          {
            text: 'CRMZ',
            value: 'CRM',
          },
          {
            text: '安华理达',
            value: 'ANL',
          },
          {
            text: '棱镜',
            value: 'RISK',
          },
        ]
      } else if (name === 'SaaS') {
        this.selectList = [
          {
            text: '棱镜',
            value: 'RISK',
          },
        ]
      } else if (name === 'LCFC') {
        this.selectList = [
          {
            text: '邓白氏',
            value: 'DNB',
          },
          {
            text: 'CRMZ',
            value: 'CRM',
          },
          {
            text: '安华理达',
            value: 'ANL',
          },
        ]
      } else {
        this.selectList = []
      }
    },
    // 导出
    exportFile() {
      download(this.searchForm)
    },
    async _getRelationList(searchForm) {
      if (this.tableLoading) {
        return
      }
      this.tableLoading = true
      const { current, pageSize } = this.pageData

      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getRelationList(formData)
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    reset() {
      this.applyRangeDate = []
      this.$refs.initSearchForm.resetFields()
    },
    handleSearch(data) {
      this.searchForm = data
      if (this.applyRangeDate) {
        data.startTime = this.applyRangeDate[0]
        data.endTime = this.applyRangeDate[1]
      }
      this.pageData.current = 1 // 设置为第一页
      this._getRelationList(data)
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getRelationList(this.searchForm)
    },
  },
  components: {
    TableView,
  },
}
</script>
<style scoped lang="less">
.ant-modal-content {
  width: 800px;
  margin-left: -100px;
}
.right {
  text-align: right;
  margin-bottom: 20px;
}
.name {
  color: #409eff;
  cursor: pointer;
}
</style>
